export function widenSidebar(): void {
    const globalSidebar = document.getElementById('globalLeftSidePanel');

    if (globalSidebar) {
        globalSidebar.style.width = '60rem';
    }
}

export function defaultenSidebar(): void {
    const globalSidebar = document.getElementById('globalLeftSidePanel');

    if (globalSidebar) {
        globalSidebar.style.width = '38rem';
    }
}

export function removeParamsFromNavItemPaths(path: string, params: { [key: string]: string }): string {
    let parameterlessPath = path;
    for (const paramKey in params) {
        if(params[paramKey]) {
            parameterlessPath = parameterlessPath.replaceAll(params[paramKey], '');
        }
    }
    if (parameterlessPath === '/') {
        return parameterlessPath.trimEnd();
    }
    // remove all trailing slashes (/),
    // this is a drawback of this algorithm
    return parameterlessPath.replace(/\/+$/, '').trimEnd();
}